"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

var _lodash = _interopRequireDefault(require("lodash"));

var _default = function _default() {
  return {
    name: 'range',
    synopsis: 'range [START] [END]',
    description: 'Generate an inclusive range',
    execute: function execute(args) {
      if (args.length !== 2) {
        throw new Error('Range must specify start and end');
      }

      var start = +args[0];
      var end = +args[1];

      if (!Number.isInteger(start) || !Number.isInteger(end)) {
        throw new Error('Range start and end must be integers');
      }

      var offset = end >= start ? 1 : -1;
      return _lodash.default.range(start, end + offset);
    }
  };
};

exports.default = _default;